
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import AccessibilityMenu from "./components/AccessibilityMenu";
import CookieConsent from "./components/CookieConsent";
import ScrollToTop from "./components/ScrollToTop";
import Index from "./pages/Index";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Enforcement from "./pages/Enforcement";
import DebtRelief from "./pages/DebtRelief";
import Insolvency from "./pages/Insolvency";
import RealEstate from "./pages/RealEstate";
import LegalAssistant from "./pages/LegalAssistant";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import DataRights from "./pages/DataRights";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <AccessibilityMenu />
      <BrowserRouter>
        <ScrollToTop />
        <CookieConsent />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/enforcement" element={<Enforcement />} />
            <Route path="/debt-relief" element={<DebtRelief />} />
            <Route path="/insolvency" element={<Insolvency />} />
            <Route path="/real-estate" element={<RealEstate />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/legal-assistant" element={<LegalAssistant />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/data-rights" element={<DataRights />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
